var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container w-96"},[_c('add-files')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }